import React from 'react'
import Box from '../../../core/components/box/Box'
import LoadingSpinner from '../../../core/components/loading-spinner/LoadingSpinner'

class Oauth extends React.PureComponent {
  componentDidMount() {
    this.form.submit()
  }

  render() {
    return (
      <Box
        display='flex'
        alignItems='center'
        justifyContent='center'
        height={300}
      >
        <form ref={node=>this.form = node} id='form-auto' method='POST' />
        <LoadingSpinner />
      </Box>
    )
  }
}

export default Oauth



// WEBPACK FOOTER //
// ./src/domains/misc/components/Oauth.js